import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { withStyles } from 'material-ui/styles';

import withAppStore from 'decorators/withAppStore';
import styles from 'styles/components/CodeInfoSection';
import ToDateNotificator from 'components/ToDateNotificator';
import { formatOrder } from 'components/CodeInfo';
import CodeInfoSection from 'components/CodeInfoSection';
import Code from '../Code';

@withStyles(styles)
@withAppStore
@observer
export default class CodeInfoDualUseGoods extends Component {

    render() {
        const { dualUseGoods } = this.props;
        const summary = getTitleSummary(dualUseGoods)
        return (
            <CodeInfoSection
                title={{
                    headers: ['Товары двойного применения'],
                    rows: summary
                }}
                expanded={(dualUseGoods.length !== 0) ? false : false}
                table={{
                    headers: [
                        '',
                        'Код',
                        'Описание',
                        'Тип',
                        'Направление',
                        'Нормативный документ'
                    ],
                    rows: dualUseGoods.map(({ to_date = null, code = '', description = '', type_dsc = '', direction_dsc = '', order, order_date, orders_info }) => ([
                        <ToDateNotificator to_date={to_date} />,
                        <Code code={code} />,
                        description,
                        type_dsc,
                        direction_dsc === '' | direction_dsc === null ? 'ЭК,ИМ' : direction_dsc,
                        formatOrder(order, order_date, orders_info)
                    ]))
                }}
            />
        );
    }
}

function getTitleSummary(items) {
    if (items.length === 0) {
        return null
    }
    var result = []
    items.filter(function (item) { return item.order }).forEach(item => {
        if (result.length === 0) {
            result.push(item);
        }
        // else if (item.order !== result.slice(-1)[0].order && item.order_date !== result.slice(-1)[0].order_date){
        else if (!(result.find((element) => element.order === item.order && element.order_date === item.order_date))) {
            result.push(item);
        }
    })
    return result.length !== 0 ? result.map(({
        type_dsc = '',
        order, order_date, orders_info = null,
    }) => ([
        `${type_dsc}`,
        formatOrder(order, order_date, orders_info),
    ])) : items.slice(0, 1).map(({
        type_dsc = '',
        order, order_date, orders_info = null,
    }) => ([
        `${type_dsc}`,
        formatOrder(order, order_date, orders_info),
    ]))

}






// WEBPACK FOOTER //
// ./src/components/codeinfo/CodeInfoDualUseGoods.js